import React, { useState } from 'react'

import ControlAlt from 'assets/icon/controls-alt.svg'
// import Avatar from 'assets/images/avatar.png'

import {
  AppHeaderControlContainer,
  AppHeaderControlIcon,
  AppHeaderControlUsername,
  // AppHeaderControlAvatar,
  AppHeaderControlDropDown,
  AppHeaderControlMenu,
  AppHeaderControlDropDownTriangle,
  AppHeaderControlLink,
} from './styled'
import { useDispatch } from 'react-redux'
import { authActions } from 'store/slices/auth'
import toast from 'cogo-toast'
import { useAppState } from 'store'

const AppHeaderControl = () => {
  const dispatch = useDispatch()
  const { user } = useAppState(state => state.auth)
  const [showDropDown, setShowDropDown] = useState<boolean>(false)

  const handleToggleDropDown = () => {
    setShowDropDown(!showDropDown)
  }

  const handleLogout = () => {
    localStorage.removeItem('1acespace')
    dispatch(authActions.cleanAuth())
    toast.success('You have successfully logged out', {
      position: 'top-right',
    })
  }

  return (
    <AppHeaderControlContainer
      onMouseEnter={handleToggleDropDown}
      onMouseLeave={handleToggleDropDown}>
      <AppHeaderControlIcon src={ControlAlt} alt="control" />
      {user && (
        <>
          <AppHeaderControlUsername>{user.name} {user.last_name}</AppHeaderControlUsername>
          {/* <AppHeaderControlAvatar src={Avatar} alt="User avatar" /> */}
        </>
      )}
      {showDropDown && (
        <AppHeaderControlDropDown>
          <AppHeaderControlDropDownTriangle />
          <AppHeaderControlMenu>
            <AppHeaderControlLink to="/profile">Profile</AppHeaderControlLink>
            <AppHeaderControlLink to="/">My Reservations</AppHeaderControlLink>
            <AppHeaderControlLink to="/" onClick={handleLogout}>
              Logout
            </AppHeaderControlLink>
          </AppHeaderControlMenu>
        </AppHeaderControlDropDown>
      )}
    </AppHeaderControlContainer>
  )
}

export default AppHeaderControl
